module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item",
    attrs: {
      "title": "Exportar"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.modalOpen('code');
        _vm.codeSetupBox(_vm.boxActive)
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-import"
  }), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.$t('general.actions.export')))])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7859ca95!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/topbar/buttons/Export.vue
 ** module id = 867
 ** module chunks = 1
 **/